// extracted by mini-css-extract-plugin
export default {"panel-toggle":"PanelModeToggle_panel-toggle__eBeKJ","panel-toggle--compact":"PanelModeToggle_panel-toggle--compact__Y9FRt"};